import LmsFormField from "../../components/LmsFormField";

const StudentForm = ({
  formData,
  onChange,
  onSubmit,
  submitLabel,
  isSubmitting,
  secondaryAction,
}) => (
  <form className="student-form" onSubmit={onSubmit}>
    <div className="student-form-grid">
      <LmsFormField
        label="First name"
        name="firstName"
        value={formData.firstName}
        onChange={onChange}
        autoComplete="given-name"
      />
      <LmsFormField
        label="Last name"
        name="lastName"
        value={formData.lastName}
        onChange={onChange}
        autoComplete="family-name"
      />
    </div>
    <LmsFormField
      label="Credential email"
      name="email"
      type="email"
      value={formData.email}
      onChange={onChange}
      autoComplete="email"
    />
    <div className="student-form-grid">
      <LmsFormField
        label="Grade"
        name="grade"
        value={formData.grade}
        onChange={onChange}
      />
      <LmsFormField
        label="Age"
        name="age"
        type="number"
        value={formData.age}
        onChange={onChange}
      />
    </div>
    <div className="student-form-actions">
      {secondaryAction}
      <button type="submit" className="lms-primary-action" disabled={isSubmitting}>
        {isSubmitting ? "Saving..." : submitLabel}
      </button>
    </div>
  </form>
);

export default StudentForm;
